import TimeSlot from "./TimePeriod";

export default TimeSlot;
